import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

export const refreshAdminSettings = (data) => { cache = Promise.resolve(data); };

export function useAdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    cache = cache || api.get("/admin/settings").then((r) => r.data).catch((e) => { cache = null; throw e; });
    cache.then(setS).catch(() => {});
  }, []);
  return s;
}
